<section 
    *ngIf="isError"
    class="approve-cancellation">
    <div class="card">
        <h3 class="card-title-bold">
            Error occured
        </h3>
        <hr class="page-divider">
        <p>Error occured when trying to cancel contract</p>
    </div>
</section>
<app-cancel-info
    *ngIf="!isError"
    [approved]="true"
></app-cancel-info>
<app-ngx-loader [loading]="isLoading"></app-ngx-loader>